/**
 * Pausa temporária das ações (criação/edição/exclusão) para empresas específicas.
 *
 * IDs do banco de produção:
 * 2  = Laticínio Scala
 * 4  = Rehsult App
 * 5  = Rehagro
 * 29 = Rehagro Grãos
 *
 * Para encerrar a pausa, esvazie a lista.
 */
export const ACTIONS_PAUSED_ENTERPRISE_IDS = [2, 4, 5, 29];

export const ACTIONS_PAUSED_MODAL_KEY = 'actionsPausedModalShown';

export const isActionsPausedForEnterprise = (enterpriseId) => ACTIONS_PAUSED_ENTERPRISE_IDS.includes(Number(enterpriseId));
